export default __webpack_public_path__ + "static/media/new-login-cover.df72f1fe.jpeg";